"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _bricksTheme = _interopRequireDefault(require("@titelmedia/bricks-theme"));
var _player = _interopRequireDefault(require("@vimeo/player"));
var _styles = require("./styles");
var _index = _interopRequireDefault(require("./tabs/index.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const PROPORTION = 1.78;
const Hero = props => {
  const {
    title,
    backgroundImage,
    vimeoId,
    svgLandscape,
    svgPortrait,
    verticalAlignment,
    horizontalAlignment,
    typeface,
    textColor,
    blackOverlay,
    customProps,
    categoryTitle,
    categoryUrl,
    editorUrl,
    editor,
    company,
    initTimelines
  } = props;
  const videoContainerRef = (0, _react.useRef)(null);
  const playerRef = (0, _react.useRef)(null);
  const initVideo = () => {
    if (playerRef.current) {
      playerRef.current.destroy();
    }
    const windowProportion = window.innerWidth / window.innerHeight;
    const vp = PROPORTION;
    let _w, _h;
    if (windowProportion > vp) {
      _w = window.innerWidth;
      _h = _w / PROPORTION;
    } else {
      _h = window.innerHeight;
      _w = _h * PROPORTION;
    }
    playerRef.current = new _player.default(videoContainerRef.current, {
      id: vimeoId,
      controls: false,
      autoplay: true,
      loop: true,
      width: _w,
      height: _h,
      muted: true,
      autopause: false
    });
  };
  const initVideoDebounced = (0, _lodash.debounce)(initVideo, 200);
  (0, _react.useEffect)(() => {
    if (vimeoId) {
      initVideo();
      window.addEventListener('resize', initVideoDebounced);
      return () => {
        window.removeEventListener('resize', initVideoDebounced);
      };
    }
  }, []);
  const showCategory = ({
    color
  }) => _react.default.createElement(_styles.MetaText, {
    color: color
  }, categoryUrl ? _react.default.createElement("a", {
    className: "link",
    href: categoryUrl
  }, categoryTitle) : categoryTitle);
  const showAuthor = ({
    color
  }) => _react.default.createElement(_styles.MetaText, {
    color: color
  }, "WORDS BY", ' ', categoryUrl ? _react.default.createElement("a", {
    className: "link",
    href: editorUrl
  }, editor) : editor);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_bricksTheme.default, null), _react.default.createElement(_styles.Container, null, _react.default.createElement(_styles.BackgroundContainer, {
    ref: videoContainerRef,
    backgroundImage: backgroundImage,
    blackOverlay: blackOverlay
  }), _react.default.createElement(_styles.InnerContainer, {
    verticalAlignment: verticalAlignment,
    horizontalAlignment: horizontalAlignment
  }, (svgLandscape || svgPortrait) && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.ImgPortrait, {
    src: svgPortrait || svgLandscape,
    alt: svgPortrait
  }), _react.default.createElement(_styles.ImgLandscape, {
    src: svgLandscape || svgPortrait,
    alt: svgLandscape
  })), !svgPortrait && !svgLandscape && title && _react.default.createElement(_styles.MetaContainer, null, _react.default.createElement(_styles.Title, {
    typeface: typeface || 'black',
    color: textColor
  }, title), _react.default.createElement(_styles.Meta, {
    color: textColor
  }, _react.default.createElement(_styles.MetaText, {
    color: textColor
  }, "(SPONSORED STORY)"), showCategory({
    color: textColor
  }), showAuthor({
    color: textColor
  }), _react.default.createElement(_styles.MetaText, {
    color: textColor
  }, "\xA9 ", company)))), _react.default.createElement(_styles.ArrowContainer, null, _react.default.createElement(_styles.Chevron, {
    viewBox: "0 0 32 32"
  }, _react.default.createElement("path", {
    stroke: textColor?.hex || 'black',
    strokeWidth: "2",
    d: "M15 6.667L28.333 20 15 33.333",
    vectorEffect: "non-scaling-stroke"
  })))), customProps && _react.default.createElement(_index.default, {
    sections: customProps.sections,
    initTimelines: initTimelines
  }));
};
exports.Hero = Hero;
//# sourceMappingURL=index.js.map